import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareCapacityRoute: InvariantJiraRoute = {
	name: 'software-capacity',
	path: '/jira/software/projects/:projectKey/boards/:boardId/capacity/:itemId?',
	query: [],
};
